export const SadBriefcase: React.FC<React.HTMLProps<SVGSVGElement>> = (props) => (
  <svg
    width="120"
    height="121"
    viewBox="0 0 120 121"
    fill="none"
    role="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_9283_113083)">
      <path
        d="M75.8004 43.0773H70.3052V32.153L68.4804 30.3282H51.5192L49.6944 32.153V43.0773H44.1992V29.8773L49.2435 24.833H70.7561L75.8004 29.8773V43.0773Z"
        fill="#1D3C81"
      />
      <path
        d="M96.6151 96.1675H23.3877L19.9531 92.733V42.9424L23.3877 39.5078H96.6151L100.05 42.9424V92.733L96.6151 96.1675Z"
        fill="#3A77FF"
      />
      <path
        d="M96.6128 39.5078L39.9531 96.1675H96.6128L100.047 92.733V42.9424L96.6128 39.5078Z"
        fill="#CEDDFF"
      />
      <path
        d="M80.0865 76.7874C80.0865 75.5015 79.0441 74.459 77.7581 74.459C76.4722 74.459 75.4297 75.5015 75.4297 76.7874C75.4297 78.0734 76.4722 79.1158 77.7581 79.1158C79.0441 79.1158 80.0865 78.0734 80.0865 76.7874Z"
        fill="#002F34"
      />
      <path
        d="M87.6334 76.7874C87.6334 75.5015 86.5909 74.459 85.305 74.459C84.019 74.459 82.9766 75.5015 82.9766 76.7874C82.9766 78.0734 84.019 79.1158 85.305 79.1158C86.5909 79.1158 87.6334 78.0734 87.6334 76.7874Z"
        fill="#002F34"
      />
      <path
        d="M80.8058 82.0691C82.851 82.0691 84.8644 82.8183 86.3164 84.2694L84.8593 85.7266C82.977 83.8451 79.7875 83.582 77.4415 85.1171L76.3136 83.3926C77.673 82.5037 79.2484 82.0691 80.8058 82.0691Z"
        fill="#002F34"
      />
      <path
        d="M107.827 45.3636L99.6094 37.1461L107.827 28.9287L116.044 37.1461L107.827 45.3636ZM104.952 37.1461L107.827 40.021L110.702 37.1461L107.827 34.2713L104.952 37.1461Z"
        fill="#FFCE32"
      />
      <path
        d="M11.0113 93.506L3.95703 86.4518L11.0113 79.3975L18.0656 86.4518L11.0113 93.506ZM9.30046 86.4518L11.0113 88.1626L12.7222 86.4518L11.0113 84.7409L9.30046 86.4518Z"
        fill="#FFCE32"
      />
    </g>
    <defs>
      <clipPath id="clip0_9283_113083">
        <rect width="120" height="120" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);
